import React from "react"
import { Div, Text } from "atomize"
import Card from "../Card"
import { theme } from "../settings/config"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTableTennisPaddleBall } from "@fortawesome/free-solid-svg-icons"
import { formatHoursAmount } from "../utils/week.utils"

const CourtsUsageCard = ({
	courtsUsage,
	selectedTimeSlot,
	courtTimeSlots,
	setSelectedTimeSlot,
	getSport,
	getSelectedSchool,
}) => {
	const hasUsage = courtsUsage && Object.keys(courtsUsage).length > 0

	const maxHours = hasUsage
		? Math.max(...Object.values(courtsUsage).flatMap(sport => Object.values(sport)))
		: 1

	return (
		<Card bg={theme.colors.surface}>
			<Div d="flex" align="center" style={{ gap: "0.5rem" }} m={{ b: "1rem" }}>
				<Div
					w="40px"
					h="40px"
					rounded="circle"
					bg={theme.colors.gunmetal_lighter}
					d="flex"
					align="center"
					justify="center">
					<FontAwesomeIcon icon={faTableTennisPaddleBall} color={theme.colors.gunmetal} />
				</Div>
				<Text textWeight="bold" textSize="title">
					Utilizzo campi
				</Text>
			</Div>

			{/* Filtro fasce orarie */}
			{courtTimeSlots && (
				<Div d="flex" style={{ gap: "0.5rem", flexWrap: "wrap" }} m={{ b: "1rem" }}>
					{courtTimeSlots.map(slot => (
						<Div
							key={slot.label}
							p="0.25rem 0.75rem"
							rounded="circle"
							cursor="pointer"
							bg={
								selectedTimeSlot?.label === slot.label
									? theme.colors.gunmetal_fill
									: theme.colors.gray_light
							}
							onClick={() => setSelectedTimeSlot(slot)}>
							<Text
								textSize="caption"
								textWeight={selectedTimeSlot?.label === slot.label && "bold"}
								textColor={
									selectedTimeSlot?.label === slot.label ? "white" : "black"
								}>
								{slot.label}
							</Text>
						</Div>
					))}
				</Div>
			)}

			{hasUsage ? (
				Object.keys(courtsUsage).map(sportID => (
					<Div key={sportID} m={{ b: "0.75rem" }}>
						<Text
							textWeight="bold"
							textSize="caption"
							textColor={theme.colors.text_light}
							textTransform="uppercase"
							m={{ b: "0.5rem" }}>
							{getSport(sportID)?.sportName}
						</Text>
						{Object.keys(courtsUsage[sportID])
							.filter(court => courtsUsage[sportID][court] > 0)
							.map(court => {
								const hours = courtsUsage[sportID][court]
								const surface =
									getSelectedSchool()?.courts?.[sportID]?.[court]?.surfaceName
								const pct = Math.round((hours / maxHours) * 100)

								return (
									<Div key={court} m={{ b: "0.6rem" }}>
										<Div
											d="flex"
											justify="space-between"
											align="center"
											m={{ b: "0.2rem" }}>
											<Text textSize="subheader">
												Campo {court}
												{surface && (
													<Text
														tag="span"
														textSize="caption"
														textColor={theme.colors.text_light}>
														{" "}
														· {surface}
													</Text>
												)}
											</Text>
											<Text
												textSize="subheader"
												textWeight="bold"
												textColor={theme.colors.gunmetal}>
												{formatHoursAmount(hours)}
											</Text>
										</Div>
										{/* Barra progresso */}
										<Div
											w="100%"
											h="6px"
											rounded="circle"
											bg={theme.colors.gray_light}>
											<Div
												w={`${pct}%`}
												h="100%"
												rounded="circle"
												bg={theme.colors.gunmetal}
												style={{ transition: "width 0.4s ease" }}
											/>
										</Div>
									</Div>
								)
							})}
					</Div>
				))
			) : (
				<Text textSize="subheader" textColor={theme.colors.text_light}>
					Nessun campo utilizzato!
				</Text>
			)}
		</Card>
	)
}

export default CourtsUsageCard
